var defaultStyles = {
  "root": "Base-InlineMessage",
  "error": "Base-InlineMessage--Error",
  "success": "Base-InlineMessage--Success",
  "warning": "Base-InlineMessage--Warning"
};

export { defaultStyles as default };
